import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../service/token-storage.service';

export const adminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const tokenStorage = inject(TokenStorageService);

  const decoded = tokenStorage.decodeToken();

  if (decoded && decoded.role === 'admin') {
    return true;
  }

  return router.createUrlTree(['/tabs/explore']);
};
